import { render, staticRenderFns } from "./project-report-lotes.vue?vue&type=template&id=323f7af1&scoped=true"
import script from "./project-report-lotes.vue?vue&type=script&lang=js"
export * from "./project-report-lotes.vue?vue&type=script&lang=js"
import style0 from "./project-report-lotes.vue?vue&type=style&index=0&id=323f7af1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f7af1",
  null
  
)

export default component.exports